import { createFileRoute } from "@tanstack/react-router";
import { redirectTo } from "@/lib/route-redirect";
export const Route = createFileRoute("/marketing/email-marketing")({ beforeLoad: redirectTo("/marketing/email-automation") });
